import { render, staticRenderFns } from "./GroupEmailsPage.vue?vue&type=template&id=4cf23819&scoped=true&"
import script from "./GroupEmailsPage.vue?vue&type=script&lang=js&"
export * from "./GroupEmailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf23819",
  null
  
)

export default component.exports